<template>
    <div class="w-full space-y-8" v-if="defect">
        <ui-header :title="`Defect #${defect.reference}`" :subtitle="'Open'">
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item label="Package">
                <template>{{ defect.packageName }}</template>
            </ui-data-grid-item>
            <ui-data-grid-item label="Description of Problem" :value="defect.descriptionOfProblem"
                               wide></ui-data-grid-item>
            <ui-data-grid-item label="Required to Make Good" :value="defect.requiredToMakeGood"
                               wide></ui-data-grid-item>
            <div :class="'lg:col-span-2'" v-if="defect.mediaUrl">
                <dt class="text-sm font-medium text-gray-500">
                    Media
                </dt>
                <dd class="mt-1 text-sm text-gray-900 w-full">
                    <img :src="defect.mediaPreviewUrl" style="max-width: 300px; max-height: 200px;"
                         v-if="isMimeTypeSupported(defect.mediaMimeType)">
                    <a :href="defect.mediaUrl" target="_blank" v-text="defect.mediaName"></a>
                </dd>
            </div>
        </ui-data-grid>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        defect: Object,
    },
    data() {
        return {}
    },
    methods: {
        isMimeTypeSupported(mimeType) {
            return ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/heic'].includes(mimeType.toLowerCase())
        },
    },
    async mounted() {
    }
}
</script>
